<template>
    <touchpoint-overview-row>
        <template slot="left">
            <div class="row">
                <div class="col-2">
                    <i :class="sourceBrickIcon" />
                </div>
                <div class="col-10">
                    <span class="title">{{sourceBrickName}}</span>
                    <br />
                    <span v-for="({operator, description}, index) in sourceConditions"
                          class="description"
                          :key="`${operator}-${index}`"
                    >{{getOperatorName(operator)}} {{audienceDisplayName}} {{description}}</span>
                </div>
            </div>
        </template>

        <template slot="center">
            <touchpoint-overview-icon-magic/>
            
            <br />
            
            <span class="description">{{connectionName}}</span>
        </template>

        <template slot="right">
            <div class="row">
                <div class="col-10">
                    <span class="title">{{destinationBrickName}}</span>

                    <br />

                    <span class="description">{{audienceDisplayName}} {{destinationConditionDescription}}</span>
                </div>
                <div class="col-2">
                    <i :class="destinationBrickIcon" />
                </div>
            </div>
        </template>
    </touchpoint-overview-row>
</template>

<script>
    import getBrickIcon from "../../../Bricks/brick-icons";
    import brickTypes from '../../../Bricks/brick-types';
    import {brickDefinitions} from "../../../Bricks/brick-definitions";
    
    import {conditionOperatorTypesByValue} from "../../../ConnectionSettings/condition-operator-types";

    import TouchpointOverviewRow from "./TouchpointOverviewRow.vue";
    import TouchpointOverviewIconMagic from "./TouchpointOverviewIconMagic.vue";
    
    export default {
        name: 'touchpoint-info-item',
        components: {
            TouchpointOverviewRow,
            TouchpointOverviewIconMagic
        },
        created() {
            this.audienceDisplayName = brickDefinitions[brickTypes.audience].displayName;
        },
        methods: {
            getOperatorName(conditionType){
                //When no operator is defined; render an empty string
                if(!conditionType){
                    return '';
                }
                
                return conditionOperatorTypesByValue[conditionType].text;
            }
        },
        computed: {
            sourceBrickIcon(){
                return getBrickIcon(
                    this.sourceBrickType, 
                    this.sourceBrickConfig
                );
            },
            destinationBrickIcon(){
                return getBrickIcon(
                    this.destinationBrickType,
                    this.destinationBrickConfig
                );
            }
        },
        data: () => ({
            audienceDisplayName: ''
        }),
        props: {
            connectionName: '',
            
            sourceBrickName: '',
            sourceBrickType: 0,
            sourceBrickConfig: {},
            destinationBrickName: '',
            destinationBrickType: 0,
            destinationBrickConfig: {},
            
            sourceConditions: {
                type: Array,
                default: () => []
            },
            
            destinationConditionDescription: ''
        }
    }
</script>

<style scoped src="../../../Style/touchpoint-info-connection-list-item-row.scss" lang="scss">
    
</style>